import SearchDetailLayout from './SearchDetailLayout';
import useSearchDetail from './useSearchDetail';
import { safeMediaUrl } from './searchMedia';
import { SEARCH_ROUTES } from './searchRoutes';
import { navigateSearch } from './searchFlow';

export default function SearchDemoLecture() {
  const { id, context, query, navigate } = useSearchDetail(3);
  const url = safeMediaUrl(query.data?.lecture_data?.demo_link);
  return <SearchDetailLayout variant="demo" title="Demo Lectures" query={query} valid={id > 0} goBack={() => navigateSearch(navigate, SEARCH_ROUTES.lectureDetail, context)}>
    {url ? <><iframe title="Demo Lectures" className="search-detail-pdf" src={url} sandbox="allow-scripts allow-same-origin allow-presentation" /><p><a href={url} target="_blank" rel="noreferrer">Open demo in a new tab</a></p></> : <p>Demo lecture is unavailable.</p>}
  </SearchDetailLayout>;
}
